/* eslint-disable jsx-a11y/href-no-hash */
import React from "react";
import styles from "./styles.css";
import { Segment, Container } from "semantic-ui-react";

export class PrivacyPolicyEN extends React.Component {
  state = {};

  setOptOut() {
    var disableStr = "ga-disable-" + window.gaProperty;
    if (document.cookie.indexOf(disableStr + "=true") > -1) {
      window[disableStr] = true;
    }
    document.cookie =
      disableStr + "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
    window[disableStr] = true;

    alert(
      "Das Tracking durch Google Analytics wurde in Ihrem Browser für diese Website deaktiviert"
    );
  }

  render() {
    return (
      <Segment style={{ padding: "4em 0em", margin: 0 }}>
        <Container text>
          <div className={styles.registerForm} style={{ fontSize: "1.33em" }}>
            <div>
              <h1>Privacy statement</h1>
              <h2>1. Data protection at a glance</h2>
              <h3>General information</h3>
              <p>
                The following notes provide a simple overview of what happens to
                your personal information when you visit our website. Personal
                information is any information that personally identifies you.
                For detailed information on the subject of data protection,
                please refer to our data protection declaration listed below
                this text.
              </p>
              <h3>Data collection on our website</h3>
              <p>
                <strong>
                  Who is responsible for data collection on this website?
                </strong>
              </p>{" "}
              <p>
                The data processing on this website is carried out by the
                website operator. Their contact data can be found in the imprint
                of this website.
              </p>{" "}
              <p>
                <strong>How do we collect your data?</strong>
              </p>{" "}
              <p>
                On the one hand, your data is collected by you communicating it
                to us. This may, for example, involve data that you enter in a
                contact form.
                <br />
                <br />
                Other data is automatically collected by our IT systems when you
                visit the website. These are mainly technical data (e.g.
                Internet browser, operating system or time of the page call).
                This data is collected automatically as soon as you enter our
                website.
              </p>
              <p>
                <strong>What do we use your data for?</strong>
              </p>{" "}
              <p>
                Some of the data is collected to ensure that the website is
                error-free. Other data may be used to analyze your user
                behavior.
              </p>{" "}
              <p>
                <strong>
                  What rights do you have with regard to your data?
                </strong>
              </p>{" "}
              <p>
                You have the right at any time and free of charge to obtain
                information about the origin, recipient and purpose of your
                stored personal data. You also have the right to demand the
                correction, blocking or deletion of this data. You can contact
                us at any time at the address given in the imprint for this and
                other questions on the subject of data protection. Furthermore,
                you have the right to appeal to the responsible supervisory
                authority.
              </p>
              <h3>Third-party analysis tools and tools</h3>{" "}
              <p>
                When you visit our website, your surfing behaviour can be
                statistically evaluated. This is done primarily with cookies and
                so-called analysis programs. The analysis of your surfing
                behaviour is usually anonymous; the surfing behaviour cannot be
                traced back to you. You can object to this analysis or prevent
                it by not using certain tools. Detailed information on this can
                be found in the following privacy statement.
              </p>{" "}
              <p>
                You can object to this analysis. We will inform you about the
                possibilities of objection in this data protection declaration.
              </p>
              <h2>2. General notes and mandatory information</h2>
              <h3>Data protection</h3>{" "}
              <p>
                The operators of these pages take the protection of your
                personal data very seriously. We treat your personal data
                confidentially and according to the legal data protection
                regulations as well as this data protection explanation.
              </p>{" "}
              <p>
                When you use this website, various personal data is collected.
                Personal information is information that personally identifies
                you. This Privacy Policy explains what information we collect
                and how we use it. It also explains how and for what purpose
                this is done.
              </p>{" "}
              <p>
                We would like to point out that data transmission over the
                Internet (e.g. communication by e-mail) can be subject to
                security vulnerabilities. A complete protection of the data
                against access by third parties is not possible.
              </p>
              <h3>Note on the responsible body</h3>{" "}
              <p>
                The responsible body for data processing on this website is:
              </p>
              <h3>
              audory UG (haftungsbeschränkt)
              </h3>
              <p>
                Technologie-Campus 1
                <br />
                09126 Chemnitz
                <br/>
                <br/>
                Handelsregister: HRB 33582
                <br/>
                Registered at Chemnitz local court
              </p>
              <hr/>
              <h3>
              Authorized representative executive director
              </h3>
              <p>
                Max Rose<br/>
                E-Mail: max.rose@audory.io<br/>
                Telefon: +49 1577 3064495
              </p>
              <hr/>
              <p>
                The responsible body is the natural or legal person who alone or
                jointly with others decides on the purposes and means of
                processing personal data (e.g. names, e-mail addresses, etc.).
              </p>
              <h3>Revocation of your consent to data processing</h3>{" "}
              <p>
                Many data processing operations are only possible with your
                express consent. You can revoke any consent you have already
                given at any time. For this purpose, an informal e-mail
                notification to us is sufficient. The legality of the data
                processing carried out until the revocation remains unaffected
                by the revocation.
              </p>
              <h3>Right to data transferability</h3>{" "}
              <p>
                You have the right to have data which we process automatically
                on the basis of your consent or in fulfilment of a contract
                handed over to you or to a third party in a common,
                machine-readable format. If you request the direct transfer of
                the data to another responsible person, this will only be done
                as far as it is technically feasible.
              </p>
              <h3>SSL or TLS encryption</h3>{" "}
              <p>
                This site uses SSL or TLS encryption for security reasons and to
                protect the transmission of confidential content, such as orders
                or enquiries that you send to us as the site operator. You can
                recognize an encrypted connection by the fact that the address
                line of the browser changes from "http://" to "https://" and by
                the lock symbol in your browser line.
              </p>{" "}
              <p>
                If SSL or TLS encryption is activated, the data you transmit to
                us cannot be read by third parties.
              </p>
              <h3>Information, blocking, deletion</h3>{" "}
              <p>
                Within the framework of the applicable legal provisions, you
                have the right at any time to free information about your stored
                personal data, their origin and recipient and the purpose of
                data processing and, if applicable, a right to correction,
                blocking or deletion of this data. You can contact us at any
                time at the address given in the imprint for this and other
                questions on the subject of personal data.
              </p>
              <h3>Objection to advertising mails</h3>{" "}
              <p>
                The use of published postal addresses, telephone or fax numbers
                and email addresses for marketing purposes is prohibited,
                offenders sending unwanted spam messages will be punished. The
                operators of this website expressly reserve the right to take
                legal action against unsolicited mailing or e-mailing of spam
                and other similar advertising materials.
              </p>
              <h2>3. Data collection on our website</h2>
              <h3>Cookies</h3>{" "}
              <p>
                Some of the Internet pages use so-called cookies. Cookies do not
                damage your computer and do not contain viruses. Cookies serve
                to make our offer more user-friendly, more effective and safer.
                Cookies are small text files that are stored on your computer by
                your browser.
                <br />
                <br />
                Most of the cookies we use are so-called "session cookies". They
                are automatically deleted at the end of your visit. Other
                cookies remain stored on your end device until you delete them.
                These cookies enable us to recognize your browser during your
                next visit.
                <br />
                <br />
                You can set your browser so that you are informed about the
                setting of cookies and only allow cookies in individual cases,
                accept cookies for certain cases or generally exclude and
                activate the automatic deletion of cookies when closing the
                browser. If cookies are deactivated, the functionality of this
                website may be restricted.
                <br />
                <br />
                Cookies that are required to carry out the electronic
                communication process or to provide certain functions you
                require (e.g. shopping basket function) are stored on the basis
                of Art. 6 para. 1 lit. f DSGVO. The website operator has a
                justified interest in the storage of cookies for the technically
                error-free and optimised provision of its services. Insofar as
                other cookies (e.g. cookies for analysing your surfing
                behaviour) are stored, these are dealt with separately in this
                data protection declaration.
              </p>
              <h3>Server log files</h3>{" "}
              <p>
                The provider of these pages automatically collects and stores
                information in so-called server log files, which your browser
                automatically transmits to us. These are:
              </p>{" "}
              <ul>
                {" "}
                <li>Browser type and browser version</li>{" "}
                <li>used operating system</li> <li>Referrer URL</li>{" "}
                <li>Hostname of the accessing computer</li>{" "}
                <li>Time of the server request</li> <li>IP-Address</li>{" "}
              </ul>{" "}
              <p>This data will not be merged with other data sources.</p>{" "}
              <p>
                This data is collected on the basis of Art. 6 para. 1 lit. f
                DSGVO. The website operator has a justified interest in the
                technically error-free presentation and optimisation of his
                website - for this purpose, the server log files must be
                recorded.
              </p>
              <h3>Contact form</h3>{" "}
              <p>
                If you send us enquiries via the contact form, your details from
                the enquiry form including the contact data you provided there
                will be stored by us for the purpose of processing the enquiry
                and in the event of follow-up questions. These data will not be
                passed on without your consent.
                <br />
                <br />
                The processing of the data entered in the contact form is
                therefore carried out exclusively on the basis of your consent
                (Art. 6 para. 1 lit. a DSGVO). You can revoke this consent at
                any time. For this purpose, an informal e-mail notification to
                us is sufficient. The legality of the data processing operations
                carried out until the revocation remains unaffected by the
                revocation.
                <br />
                <br />
                The data entered by you in the contact form will remain with us
                until you request deletion, revoke your consent to storage or
                the purpose for data storage no longer applies (e.g. after your
                request has been processed). Mandatory legal provisions - in
                particular retention periods - remain unaffected.
              </p>
              <h3>Registration on this website</h3>{" "}
              <p>
                You can register on our website in order to use additional
                functions on the site. We only use the data entered for this
                purpose for the purpose of using the respective offer or service
                for which you have registered. The mandatory information
                requested during registration must be provided in full.
                Otherwise we will refuse the registration.
                <br />
                <br />
                In the case of important changes, for example in the scope of
                our services or in the case of technically necessary changes, we
                will use the e-mail address provided during registration to
                inform you in this way.
                <br />
                <br />
                The data entered during registration will be processed on the
                basis of your consent (Art. 6 para. 1 lit. a DSGVO). You can
                revoke your consent at any time. For this purpose, an informal
                e-mail notification to us is sufficient. The legality of the
                data processing already carried out remains unaffected by the
                revocation.
                <br />
                <br />
                The data collected during registration will be stored by us as
                long as you are registered on our website and will subsequently
                be deleted. Legal retention periods remain unaffected.
              </p>
              <h3>Register with Facebook Connect</h3>{" "}
              <p>
                Instead of registering directly on our website, you can use
                Facebook Connect to register. This service is provided by
                Facebook Ireland Limited, 4 Grand Canal Square, Dublin 2,
                Ireland.
                <br />
                <br />
                If you decide to register with Facebook Connect and click on the
                "Login with Facebook" / "Connect with Facebook" button, you will
                automatically be redirected to the Facebook platform. There you
                can log in with your usage data. This links your Facebook
                profile to our website or services. This link gives us access to
                your data stored on Facebook. These are above all:
              </p>{" "}
              <ul>
                {" "}
                <li>Facebook-Name</li>{" "}
                <li>Facebook-Profile- und Coverpicture</li>{" "}
                <li>E-mail address stored on Facebook</li> <li>Facebook-ID</li>
                <li>Date of Birth</li> <li>Country</li> <li>Language</li>{" "}
              </ul>{" "}
              <p>
                This data is used to set up, provide and personalize your
                account.
              </p>{" "}
              <p>
                For more information, see the Facebook Terms of Use and Facebook
                Privacy Policy. These can be found at:
                <a
                  href="https://www.facebook.com/about/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.facebook.com/about/privacy/
                </a>{" "}
                und{" "}
                <a
                  href="https://www.facebook.com/legal/terms/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.facebook.com/legal/terms/
                </a>
                .
              </p>
              <h2>4. Analysis tools and advertising</h2>
              <h3>Google Analytics</h3>{" "}
              <p>
                This website uses functions of the web analysis service Google
                Analytics. The provider is Google Inc., 1600 Amphitheatre
                Parkway, Mountain View, CA 94043, USA.
                <br />
                <br />
                Google Analytics uses so-called "cookies". These are text files
                which are stored on your computer and which enable an analysis
                of your use of the website. The information generated by the
                cookie about your use of the website will generally be
                transmitted to and stored by Google on servers in the United
                States.
                <br />
                <br />
                Google Analytics cookies are stored on the basis of Art. 6 para.
                1 lit. f DSGVO. The website operator has a legitimate interest
                in analysing user behaviour in order to optimise both its
                website and its advertising.
              </p>
              <p>
                <strong>IP Anonymization</strong>
              </p>{" "}
              <p>
                We have enabled the IP Anonymization feature on this website. As
                a result, your IP address will be shortened by Google within
                member states of the European Union or in other signatory states
                to the Agreement on the European Economic Area prior to
                transmission to the USA. Only in exceptional cases is the full
                IP address transmitted to a Google server in the USA and
                shortened there. On behalf of the operator of this website,
                Google will use this information to evaluate your use of the
                website, to compile reports on website activity and to provide
                other services relating to website activity and internet usage
                to the website operator. The IP address transmitted by your
                browser as part of Google Analytics is not combined with other
                data from Google.
              </p>
              <p>
                <strong>Browser Plugin</strong>
              </p>{" "}
              <p>
                You may refuse the use of cookies by selecting the appropriate
                settings on your browser, however please note that if you do
                this you may not be able to use the full functionality of this
                website. In addition, you can prevent Google from collecting the
                data generated by the cookie and related to your use of the
                website (including your IP address) and Google from processing
                this data by downloading and installing the browser plug-in
                available under the following link:
                <a
                  href="https://tools.google.com/dlpage/gaoptout?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tools.google.com/dlpage/gaoptout?hl=de
                </a>
                .
              </p>{" "}
              <p>
                <strong>Objection to data collection</strong>
              </p>{" "}
              <p>
                You can prevent Google Analytics from collecting your
                information by clicking on the following link. An opt-out cookie
                is set to prevent your information from being collected on
                future visits to this website:
                <a href="#" onClick={this.setOptOut}>
                  Google Analytics deactivation
                </a>
                .
              </p>{" "}
              <p>
                For more information on how Google Analytics uses user data,
                please see Google's privacy policy:
                <a
                  href="https://support.google.com/analytics/answer/6004245?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://support.google.com/analytics/answer/6004245?hl=de
                </a>
                .
              </p>
              <p>
                <strong>Order data processing</strong>
              </p>{" "}
              <p>
                We have concluded a contract with Google for order data
                processing and fully implement the strict requirements of the
                German data protection authorities when using Google Analytics.
              </p>
              <h2>5. Newsletter</h2>
              <h3>Newsletter data</h3>{" "}
              <p>
                If you would like to receive the newsletter offered on the
                website, we require an e-mail address from you as well as
                information that allows us to verify that you are the owner of
                the e-mail address provided and that you agree to receive the
                newsletter. Further data will not be collected or will only be
                collected on a voluntary basis. We use these data exclusively
                for the dispatch of the requested information and do not pass
                these on to third parties.
                <br />
                <br />
                The data entered in the newsletter registration form will be
                processed exclusively on the basis of your consent (Art. 6 para.
                1 lit. a DSGVO). You can revoke your consent to the storage of
                data, e-mail address and their use for sending the newsletter at
                any time, for example via the "Unsubscribe" link in the
                newsletter. The legality of the data processing operations that
                have already taken place remains unaffected by the revocation.
                <br />
                <br />
                The data that you have stored with us for the purpose of
                subscribing to the newsletter will be stored by us until you
                unsubscribe from the newsletter and deleted after you cancel the
                newsletter. This does not affect data stored by us for other
                purposes (e.g. e-mail addresses for the member area).
              </p>
              <h2>6. Plugins and Tools</h2>
              <h3>YouTube</h3>{" "}
              <p>
                Our website uses plugins from the YouTube page operated by
                Google. The site is operated by YouTube, LLC, 901 Cherry Ave,
                San Bruno, CA 94066, USA.
                <br />
                <br />
                When you visit one of our pages equipped with a YouTube plug-in,
                a connection is established to YouTube's servers. This will tell
                the YouTube server which of our pages you have visited.
                <br />
                <br />
                If you are logged in to your YouTube account, you can allow
                YouTube to associate your surfing behaviour directly with your
                personal profile. You can prevent this by logging out of your
                YouTube account.
                <br />
                <br />
                YouTube is used in the interest of an appealing presentation of
                our online offers. This constitutes a legitimate interest within
                the meaning of Art. 6 para. 1 lit. f DSGVO.
                <br />
                <br />
                Further information on the handling of user data can be found in
                YouTube's data protection declaration: <br />
                <a
                  href="https://www.google.de/intl/de/policies/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.google.de/intl/de/policies/privacy
                </a>
                .
              </p>
            </div>
          </div>
        </Container>
      </Segment>
    );
  }
}

export default PrivacyPolicyEN;



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/PrivacyPolicyEN.js